import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  NitroPanel,
  NitroTabs,
  NitroText,
  NitroIcon,
  NitroSingleSelect,
  NitroButton
} from 'nitro-components';

import {
  getInputText,
  getSeletedType,
  onSelect,
  onActionSelect,
  onInput,
  getUsers,
  retriveUsers,
  getActionType
} from './store/action';

import Breakpoint from '../../utils/breakpoints';
import {
  EntryCountContainer,
  Container,
  SearchResultStyleHeader,
  SearchResultContainer,
  Main,
  NavContainer,
  TabContainer,
  NumPerPageOptionContainer,
  SearchTypeSelector,
  SearchContainer
} from './ResultStyle';
import { INSIGHTS } from '../../routes/const';
import DetailedSearchResultContainer from './DetailedSearchResultContainer';
import SearchBar from './SearchBar';
import BulkSelectIcon from './BulkSelect.svg';

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 'Users'
    };
  }

  componentWillMount() {
    this.props.retriveUsers({
      fetchParams: {
        limit: 15,
        offset: 0
      }
    });
  }
  render() {
    const { actionType, actionOptions, onActionSelect } = this.props;
    const goHome = () => {
      const { router } = this.context;
      router.push(INSIGHTS);
    };
    const tabs = [
      {
        key: 'Users',
        label: '',
        content: (
          <div>
            <NitroIcon
              name="profile"
              variant={this.state.tabValue === 'Users' ? 'primary' : 'base2'}
            />{' '}
            <NitroText
              size="14"
              variant={this.state.tabValue === 'Users' ? 'primary' : 'base2'}
              bold
            >
              Users
            </NitroText>
          </div>
        )
      },
      {
        key: 'Roles',
        label: '',
        content: (
          <NitroText
            size="14"
            variant={this.state.tabValue === 'Roles' ? 'primary' : 'base2'}
            bold
          >
            Roles
          </NitroText>
        )
      }
    ];
    const handleTabChange = object => {
      this.setState({
        tabValue: object.key
      });
    };

    const fetchUsers = queryOpts => {
      this.props.retriveUsers({
        fetchParams: {
          limit: 15,
          offset: 0,
          ...queryOpts
        }
      });
    };
    return (
      <Main>
        <NavContainer>
          <TabContainer onClick={goHome}>Home</TabContainer> / User Management
        </NavContainer>

        <Container>
          <NitroPanel>
            <Breakpoint name="desktop">
              <SearchResultStyleHeader>User Management</SearchResultStyleHeader>
              <SearchContainer>
                <NitroTabs
                  data={tabs}
                  active="Users"
                  action={handleTabChange}
                  variant="primary"
                />
                <NitroButton
                  label="CREATE USER"
                  size="small"
                  variant="primary"
                  action={() => console.log('Create')}
                />
              </SearchContainer>

              <SearchContainer>
                <SearchBar tabValue={this.state.tabValue} />
                <NumPerPageOptionContainer>
                  <span>CHOOSE</span>
                  <SearchTypeSelector>
                    <NitroSingleSelect
                      value={actionType}
                      options={actionOptions}
                      mandatory
                      bold
                      placeholder="Action"
                      action={onActionSelect}
                    />
                  </SearchTypeSelector>
                  <span>
                    <img
                      src={BulkSelectIcon}
                      alt="close icon"
                      // action={() => console.log('bulk action')}
                    />
                  </span>
                </NumPerPageOptionContainer>
              </SearchContainer>
              {this.state.tabValue === 'Users' ? (
                <Breakpoint name="mobileTablet">
                  <DetailedSearchResultContainer />
                </Breakpoint>
              ) : (
                <Breakpoint name="mobileTablet">Role holder</Breakpoint>
              )}
              {this.state.tabValue === 'Users' ? (
                <Breakpoint name="desktop">
                  <SearchResultContainer>
                    <DetailedSearchResultContainer />
                  </SearchResultContainer>
                </Breakpoint>
              ) : (
                <Breakpoint name="desktop">Role holder</Breakpoint>
              )}
            </Breakpoint>
          </NitroPanel>
        </Container>
      </Main>
    );
  }
}

const mapStateToProps = state => {
  const { data, paging } = getUsers(state);
  return {
    searchTerm: getInputText(state),
    searchType: getSeletedType(state),
    actionType: getActionType(state),
    users: data,
    total: paging.totalRecordCount
  };
};

const mapDispatchToProps = dispatch => ({
  retriveUsers: bindActionCreators(retriveUsers, dispatch),
  onSelect: bindActionCreators(onSelect, dispatch),
  onActionSelect: bindActionCreators(onActionSelect, dispatch),
  onInput: bindActionCreators(onInput, dispatch)
});

UserManagement.contextTypes = {
  router: PropTypes.shape({})
};

UserManagement.propTypes = {
  actionType: PropTypes.string,
  users: PropTypes.arrayOf(PropTypes.shape({})),
  currentPage: PropTypes.number
};

UserManagement.defaultProps = {
  users: [],
  actionOptions: ['Lock', 'Unlock', 'Terminate', 'Reactivate'].map(i => ({
    label: i,
    value: i
  })),
  currentPage: 0
};
export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);



// WEBPACK FOOTER //
// ./src/features/userManagement/UserManagementContainer.js